import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import ProjectsPage from './ProjectsRoutes/ProjectsPage';
import ProjectPage from './ProjectsRoutes/ProjectPage';
import {ModalRoute} from 'react-router-modal';
import GraduateModal from './Modals/GraduateModal';

class ProjectsRouter extends Component {
    render() {
        return (
            <div>
                <Switch>
                    <Route path={"/projects"} exact component={ProjectsPage}/>
                    <Route path={"/projects/:key"} component={ProjectPage}/>
                </Switch>
                <ModalRoute parentPath={()=>{
                    // Sets the parent path by removing the final
                    let path = this.props.location.pathname.split('/');
                    path.pop();
                    return path.join('/');
                }} path={'/projects/:key/:unikey'} component={GraduateModal}/>
            </div>
        );
    }
}



export default ProjectsRouter;
